<ion-header class="ion-no-border">
	<div>{{'changeWorkspaceName.message' | translate}}</div>
</ion-header>
<div class="inner-content">
	<form [formGroup]="editWorkFileForm">
		<ion-input
			data-cy="workFileName"
			type="text"
			name="workFile"
			ngDefaultControl
			required
			formControlName="workFile"
			[ngClass]="displayError ? 'input-error' : ''"
		></ion-input>

		<div *ngIf="displayError" class="error-message">{{ errorMessage }}</div>
	</form>
</div>
<ion-footer class="ion-no-border">
	<ion-button
		data-cy="cancelButton"
		item-start
		class="cancel-button ion-no-padding ion-no-margin"
		expand="block"
		[disabled]="!editWorkFileForm.valid || displayError"
		(click)="closeModal()"
		fill="clear"
	>
		{{'changeWorkspaceName.buttons.cancelButton.label' | translate}}
	</ion-button>
	<ion-button
		data-cy="saveButton"
		item-end
		class="save-button ion-no-padding ion-no-margin"
		expand="block"
		[disabled]="!editWorkFileForm.valid"
		(click)="renameFile()"
		fill="clear"
	>
		{{'changeWorkspaceName.buttons.saveButton.label' | translate}}
	</ion-button>
</ion-footer>
